/**
 * Build a RegExp from a Go template string by replacing `{{...}}`
 * placeholders with `.*` wildcards and escaping the literal parts.
 *
 * Example:
 *   "EXTSECURE {{default \"AE\" .Data.case_type}} Case ID: {{.Code}}"
 *   → /^EXTSECURE.*Case ID\:.*$/i
 */
export function buildGoTemplatePattern(template: string): RegExp {
  const parts = template.split(/\{\{.*?\}\}/);
  const escaped = parts.map(p => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  return new RegExp(`^${escaped.join('.*')}$`, 'i');
}
